import React, {useEffect, useState} from 'react';
import {Button, Checkbox, Form, Input, Modal, Segment} from "semantic-ui-react";
import Info from "../../../../components/Info";
import DragAndDrop from "../../../../components/DragAndDrop";
import ConfirmModal from "../../../../components/Modals/ConfirmModal";

const RepresentationModal = ({open, onClose, representation, columns, onSave, onDelete, loading}) => {
    const [form, setForm] = useState({})
    const [delOpen, setDelOpen] = useState(false)

    const onChange = (e, {value, checked, name}) => {
        setForm(f => ({
            ...f,
            [name]: checked || value
        }))
    }

    useEffect(() => {
        if (open && representation) {
            // Автоматически добавляем Ext1 и Ext2 при загрузке существующего отчета
            const cols = [...(representation.columns || [])];
            const columnNames = cols.map(c => c.name);
            
            // Добавляем senderExt1 после senderContactInfo, если телефон есть, а Ext1 нет
            if (columnNames.includes('senderContactInfo') && !columnNames.includes('senderExt1')) {
                const senderPhoneIndex = cols.findIndex(c => c.name === 'senderContactInfo');
                if (senderPhoneIndex >= 0) {
                    const ext1Column = columns.find(col => col.id === 'senderExt1');
                    if (ext1Column) {
                        cols.splice(senderPhoneIndex + 1, 0, {
                            name: 'senderExt1',
                            order: senderPhoneIndex + 2
                        });
                        // Пересчитываем порядок для всех последующих колонок
                        for (let j = senderPhoneIndex + 2; j < cols.length; j++) {
                            cols[j].order = j + 1;
                        }
                    }
                }
            }
            
            // Добавляем recipientExt1 после recipientContactInfo, если телефон есть, а Ext1 нет
            if (columnNames.includes('recipientContactInfo') && !columnNames.includes('recipientExt1')) {
                const recipientPhoneIndex = cols.findIndex(c => c.name === 'recipientContactInfo');
                if (recipientPhoneIndex >= 0) {
                    const ext1Column = columns.find(col => col.id === 'recipientExt1');
                    if (ext1Column) {
                        cols.splice(recipientPhoneIndex + 1, 0, {
                            name: 'recipientExt1',
                            order: recipientPhoneIndex + 2
                        });
                        // Пересчитываем порядок для всех последующих колонок
                        for (let j = recipientPhoneIndex + 2; j < cols.length; j++) {
                            cols[j].order = j + 1;
                        }
                    }
                }
            }
            
            // Добавляем senderExt2 после senderAdditionalPhone, если дополнительный телефон есть, а Ext2 нет
            if (columnNames.includes('senderAdditionalPhone') && !columnNames.includes('senderExt2')) {
                const senderAdditionalPhoneIndex = cols.findIndex(c => c.name === 'senderAdditionalPhone');
                if (senderAdditionalPhoneIndex >= 0) {
                    const ext2Column = columns.find(col => col.id === 'senderExt2');
                    if (ext2Column) {
                        cols.splice(senderAdditionalPhoneIndex + 1, 0, {
                            name: 'senderExt2',
                            order: senderAdditionalPhoneIndex + 2
                        });
                        // Пересчитываем порядок для всех последующих колонок
                        for (let j = senderAdditionalPhoneIndex + 2; j < cols.length; j++) {
                            cols[j].order = j + 1;
                        }
                    }
                }
            }
            
            // Добавляем recipientExt2 после recipientAdditionalPhone, если дополнительный телефон есть, а Ext2 нет
            if (columnNames.includes('recipientAdditionalPhone') && !columnNames.includes('recipientExt2')) {
                const recipientAdditionalPhoneIndex = cols.findIndex(c => c.name === 'recipientAdditionalPhone');
                if (recipientAdditionalPhoneIndex >= 0) {
                    const ext2Column = columns.find(col => col.id === 'recipientExt2');
                    if (ext2Column) {
                        cols.splice(recipientAdditionalPhoneIndex + 1, 0, {
                            name: 'recipientExt2',
                            order: recipientAdditionalPhoneIndex + 2
                        });
                        // Пересчитываем порядок для всех последующих колонок
                        for (let j = recipientAdditionalPhoneIndex + 2; j < cols.length; j++) {
                            cols[j].order = j + 1;
                        }
                    }
                }
            }
            
            setForm({
                ...representation,
                columns: cols
            });
        } else if (open) {
            setForm({});
        }
    }, [open, representation, columns])

    const getItems = (isRight) => {
        const right = (form.columns || []).map(c => {
            const col = columns.find(col => col.id === c.name);
            return {
                id: c.name,
                displayNameKey: col && col.displayNameKey
            };
        }).filter(item => item.displayNameKey); // Фильтруем элементы без displayNameKey (undefined)
        
        if (isRight) return right;
        // Фильтруем поля Ext1, Ext2 и старые поля "Добавочный телефон" из левого списка (неиспользуемые данные), но они могут быть добавлены автоматически
        return columns.filter(col => {
            const isHiddenField = col.id === 'senderExt1' || col.id === 'senderExt2' || 
                                  col.id === 'recipientExt1' || col.id === 'recipientExt2' ||
                                  col.id === 'senderAdditional' || col.id === 'recipientAdditional';
            return !isHiddenField && !(right.map(c => c.id).includes(col.id)) && col.displayNameKey;
        });
    }

    const onChangeDnd = (d) => {
        const previousColumns = (form.columns || []).map(c => c.name);
        const newColumns = d.map(cl => cl.id);
        
        let cols = [];
        d.forEach((cl, i) => {
            // Проверяем, что колонка существует в списке доступных колонок
            const colExists = columns.find(col => col.id === cl.id);
            if (!colExists) {
                return; // Пропускаем несуществующие колонки
            }
            
            const colData = (form.columns || []).find(c => c.name === cl.id);
            cols.push({
                ...colData,
                name: cl.id,
                order: i + 1
            });
        });

        // Автоматически добавляем Ext1 при добавлении телефона
        // Проверяем, был ли добавлен телефон отправителя
        if (!previousColumns.includes('senderContactInfo') && newColumns.includes('senderContactInfo')) {
            // Добавляем senderExt1 после senderContactInfo, если его еще нет
            const senderPhoneIndex = cols.findIndex(c => c.name === 'senderContactInfo');
            const ext1Exists = cols.some(c => c.name === 'senderExt1');
            if (!ext1Exists && senderPhoneIndex >= 0) {
                // Проверяем, что поле senderExt1 существует в списке доступных колонок
                const ext1Column = columns.find(col => col.id === 'senderExt1');
                if (ext1Column) {
                    cols.splice(senderPhoneIndex + 1, 0, {
                        name: 'senderExt1',
                        order: senderPhoneIndex + 2
                    });
                    // Пересчитываем порядок для всех последующих колонок
                    for (let j = senderPhoneIndex + 2; j < cols.length; j++) {
                        cols[j].order = j + 1;
                    }
                }
            }
        }
        
        // Проверяем, был ли добавлен телефон получателя
        if (!previousColumns.includes('recipientContactInfo') && newColumns.includes('recipientContactInfo')) {
            // Добавляем recipientExt1 после recipientContactInfo, если его еще нет
            const recipientPhoneIndex = cols.findIndex(c => c.name === 'recipientContactInfo');
            const ext1Exists = cols.some(c => c.name === 'recipientExt1');
            if (!ext1Exists && recipientPhoneIndex >= 0) {
                // Проверяем, что поле recipientExt1 существует в списке доступных колонок
                const ext1Column = columns.find(col => col.id === 'recipientExt1');
                if (ext1Column) {
                    cols.splice(recipientPhoneIndex + 1, 0, {
                        name: 'recipientExt1',
                        order: recipientPhoneIndex + 2
                    });
                    // Пересчитываем порядок для всех последующих колонок
                    for (let j = recipientPhoneIndex + 2; j < cols.length; j++) {
                        cols[j].order = j + 1;
                    }
                }
            }
        }
        
        // Автоматически добавляем Ext2 при добавлении дополнительного телефона отправителя
        if (!previousColumns.includes('senderAdditionalPhone') && newColumns.includes('senderAdditionalPhone')) {
            const senderAdditionalPhoneIndex = cols.findIndex(c => c.name === 'senderAdditionalPhone');
            const ext2Exists = cols.some(c => c.name === 'senderExt2');
            if (!ext2Exists && senderAdditionalPhoneIndex >= 0) {
                const ext2Column = columns.find(col => col.id === 'senderExt2');
                if (ext2Column) {
                    cols.splice(senderAdditionalPhoneIndex + 1, 0, {
                        name: 'senderExt2',
                        order: senderAdditionalPhoneIndex + 2
                    });
                    // Пересчитываем порядок для всех последующих колонок
                    for (let j = senderAdditionalPhoneIndex + 2; j < cols.length; j++) {
                        cols[j].order = j + 1;
                    }
                }
            }
        }
        
        // Автоматически добавляем Ext2 при добавлении дополнительного телефона получателя
        if (!previousColumns.includes('recipientAdditionalPhone') && newColumns.includes('recipientAdditionalPhone')) {
            const recipientAdditionalPhoneIndex = cols.findIndex(c => c.name === 'recipientAdditionalPhone');
            const ext2Exists = cols.some(c => c.name === 'recipientExt2');
            if (!ext2Exists && recipientAdditionalPhoneIndex >= 0) {
                const ext2Column = columns.find(col => col.id === 'recipientExt2');
                if (ext2Column) {
                    cols.splice(recipientAdditionalPhoneIndex + 1, 0, {
                        name: 'recipientExt2',
                        order: recipientAdditionalPhoneIndex + 2
                    });
                    // Пересчитываем порядок для всех последующих колонок
                    for (let j = recipientAdditionalPhoneIndex + 2; j < cols.length; j++) {
                        cols[j].order = j + 1;
                    }
                }
            }
        }
        
        // Если телефон удален, удаляем и Ext1
        if (previousColumns.includes('senderContactInfo') && !newColumns.includes('senderContactInfo')) {
            cols = cols.filter(c => c.name !== 'senderExt1');
            // Пересчитываем порядок
            cols.forEach((col, index) => {
                col.order = index + 1;
            });
        }
        
        if (previousColumns.includes('recipientContactInfo') && !newColumns.includes('recipientContactInfo')) {
            cols = cols.filter(c => c.name !== 'recipientExt1');
            // Пересчитываем порядок
            cols.forEach((col, index) => {
                col.order = index + 1;
            });
        }
        
        // Если дополнительный телефон удален, удаляем и Ext2
        if (previousColumns.includes('senderAdditionalPhone') && !newColumns.includes('senderAdditionalPhone')) {
            cols = cols.filter(c => c.name !== 'senderExt2');
            // Пересчитываем порядок
            cols.forEach((col, index) => {
                col.order = index + 1;
            });
        }
        
        if (previousColumns.includes('recipientAdditionalPhone') && !newColumns.includes('recipientAdditionalPhone')) {
            cols = cols.filter(c => c.name !== 'recipientExt2');
            // Пересчитываем порядок
            cols.forEach((col, index) => {
                col.order = index + 1;
            });
        }
        
        onChange(null, {name: 'columns', value: cols})
    }

    return (
        <Modal
            closeIcon
            onClose={onClose}
            open={open}
            size="small"
            id="fieldModal"
        >
            <Modal.Header className='modal__label_center'>
                {representation ? `Настройка данных отчета` : 'Создать новый отчет'}
            </Modal.Header>
            <Modal.Content className='modal__content representation-content'>
                <div className='representation-content__name-block'>
                    <Form>
                        <Form.Field inline>
                            <label>Название</label>
                            <Input
                                value={form.name || ''}
                                name='name'
                                onChange={onChange}
                            />
                        </Form.Field>
                        {((representation || {}).isUserView || !representation) && <Form.Field className='result-step__item'>
                            <Checkbox
                                checked={form.isDefault || false}
                                name='isDefault'
                                onChange={onChange}
                            />
                            <div className='checkbox-label'>
                                Сделать основным
                                <Info
                                    name={'Основной отчет'}
                                    text={'Данный отчет будет открываться сразу при переходе в раздел “Мои отчеты”'}
                                />
                            </div>

                        </Form.Field>}
                    </Form>
                </div>
                <Segment vertical>
                    <div className='representation-content__dnd scroll-style'>
                        <DragAndDrop
                            key={'DragAndDrop'}
                            left={getItems()}
                            right={getItems(true)}
                            search={''}
                            t={(w) => w + ''}
                            onChange={onChangeDnd}
                            columns={[
                                {
                                    title: 'Неиспользуемые данные'
                                },
                                {
                                    title: 'Данные вашего отчета'
                                }
                            ]}
                        />
                    </div>
                </Segment>
            </Modal.Content>
            <Modal.Actions className='modal__actions modal__actions_with-description'>
                <div>
                    <Button loading={loading} disabled={loading} className='modal__actions_yes' onClick={() => onSave(form)}>ПОДТВЕРДИТЬ</Button>
                </div>
                <div className='modal-description'>
                    <div className='personal-data'>
                        Проверьте правильность данных и нажмите кнопку “Подтвердить”
                    </div>
                </div>
                {(representation && representation.isUserView) && <div className='m-t-7'>
                    <div className='personal-data'>
                        <a onClick={() => setDelOpen(true)}>Удалить отчет</a>
                    </div>
                </div>}
            </Modal.Actions>
            <ConfirmModal
                open={delOpen}
                onConfirm={() => {
                    onDelete(form.id);
                    onClose();
                }}
                setOpen={setDelOpen}
                label={'Удаление отчета'}
            >
                Вы действительно уверены, что хотите удалить отчет?
            </ConfirmModal>
        </Modal>
    );
};

export default RepresentationModal;


// WEBPACK FOOTER //
// ./App/pages/reports/components/representation/representationModal.jsx